import { render, staticRenderFns } from "./MitVolumeDetails.vue?vue&type=template&id=3aa73a35&scoped=true"
import script from "./MitVolumeDetails.vue?vue&type=script&lang=js"
export * from "./MitVolumeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa73a35",
  null
  
)

export default component.exports